import styled from "styled-components";
import { colors, sizing } from "./variables.js";

const Tag = styled.p`
   display: flex;
   align-items: center;
   height: 1.7rem;
   padding: 0 1rem;
   font-size: 0.8rem;
   white-space: nowrap;
   margin-right: 0.6rem;
   border-radius: 0 ${sizing.borderRadius4} ${sizing.borderRadius4};
   background: ${colors.secondary2};
   color: ${colors.primary1};

   @media (max-width: 500px) {
      font-size: 0.85rem;
      margin-bottom: 0.6rem;
   }
`;

export default Tag;
